/**
 * Asistente del formulario de solicitud a medida de Reyes Magos.
 *
 * Cinco pasos con tres ramas que se pueden marcar a la vez, así que el recorrido
 * tiene entre cuatro y seis pantallas. El modal ya viene pintado entero en el
 * HTML: aquí solo se decide cuál se ve.
 *
 * Tres cosas que conviene saber antes de tocar esto:
 *
 * - El nonce se pide al abrir, no viene en la página. El edge cachea el HTML y
 *   un nonce impreso se serviría caducado y compartido entre visitantes.
 * - Las fechas del viaje completo que se pintan aquí son solo para verlas. Las
 *   que van al correo las recalcula PHP, porque lo que manda el navegador no
 *   decide nada.
 * - El progreso se guarda en sessionStorage. El recorrido completo son unos
 *   veinticinco campos y perderlos por un clic sería feo.
 */
(function () {
	'use strict';

	var raiz = document.querySelector('[data-reyes-sol]');

	if (!raiz) {
		return;
	}

	var CLAVE = 'bex-reyes-solicitud';
	var RAMAS = ['noches', 'familiares', 'casablanca'];
	var MESES = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio',
		'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];

	var form = raiz.querySelector('[data-reyes-sol-form]');
	var cuerpo = raiz.querySelector('[data-cuerpo]');
	var dialogo = raiz.querySelector('.reyes-sol__dialogo');
	var elTitulo = raiz.querySelector('[data-titulo]');
	var elSubtitulo = raiz.querySelector('[data-subtitulo]');
	var btnAtras = raiz.querySelector('[data-accion="atras"]');
	var btnContinuar = raiz.querySelector('[data-accion="continuar"]');
	var btnOmitir = raiz.querySelector('[data-accion="omitir"]');
	var btnCancelar = raiz.querySelector('[data-accion="cancelar"]');
	var textoContinuar = raiz.querySelector('[data-continuar-texto]');
	var errorGlobal = raiz.querySelector('[data-error-global]');
	var pie = raiz.querySelector('[data-pie]');

	var pasos = {};
	Array.prototype.forEach.call(raiz.querySelectorAll('[data-paso]'), function (p) {
		pasos[p.getAttribute('data-paso')] = p;
	});

	var secuencia = [];
	var indice = 0;
	var enviando = false;
	var ultimoFoco = null;

	// ---------- la secuencia de pasos ----------

	function ramasMarcadas() {
		return RAMAS.filter(function (r) {
			var c = form.querySelector('[data-rama][value="' + r + '"]');
			return c && c.checked;
		});
	}

	function recalcularSecuencia() {
		secuencia = ['1'].concat(ramasMarcadas().map(function (r) {
			return 'rama-' + r;
		})).concat(['actividades', 'contacto', 'gracias']);
	}

	function pasoActual() {
		return secuencia[indice];
	}

	// ---------- pintar ----------

	function pintar() {
		var actual = pasoActual();

		Object.keys(pasos).forEach(function (nombre) {
			pasos[nombre].hidden = nombre !== actual;
		});

		var seccion = pasos[actual];
		elTitulo.textContent = seccion.getAttribute('data-titulo-paso') || '';

		var sub = seccion.getAttribute('data-subtitulo-paso') || '';
		elSubtitulo.textContent = sub;
		elSubtitulo.hidden = !sub;

		btnAtras.hidden = indice === 0 || actual === 'gracias';
		btnCancelar.hidden = indice !== 0;
		btnOmitir.hidden = actual !== 'actividades';
		pie.hidden = actual === 'gracias';

		textoContinuar.textContent = actual === 'contacto'
			? btnContinuar.getAttribute('data-texto-enviar') || 'Enviar solicitud'
			: btnContinuar.getAttribute('data-texto-continuar') || 'Continuar';

		colocarOrganiza();

		pintarResumen();
		cuerpo.scrollTop = 0;
	}

	/**
	 * Abre o cierra el bloque de «tu selección actual».
	 *
	 * Si no hay composición elegida se abre solo, porque es obligatoria: dejarla
	 * escondida detrás de «Editar» hacía que «Continuar» no hiciera nada y que el
	 * aviso se pintara dentro de un bloque invisible.
	 */
	function abrirSeleccion(abierto) {
		var campos = raiz.querySelector('[data-seleccion-campos]');
		var resumen = raiz.querySelector('[data-seleccion-resumen]');
		var editar = raiz.querySelector('[data-accion="editar"]');

		if (!campos) { return; }

		campos.hidden = !abierto;
		if (resumen) { resumen.hidden = abierto; }
		if (editar) { editar.hidden = abierto; }
	}

	function faltaComposicion() {
		var comp = form.querySelector('[data-campo="composicion_slug"]');
		return !comp || !comp.value;
	}

	/**
	 * Lleva el bloque de «quién organiza el viaje» al paso donde toca.
	 *
	 * Es uno solo en todo el asistente y se mueve por el DOM: al primer paso de
	 * rama que haya, o al de contacto si no se ha marcado ninguna. Repetirlo por
	 * rama hacía que los radios de «¿ya tienes una reserva?» compartieran grupo
	 * y no se pudiera marcar ninguno.
	 */
	function colocarOrganiza() {
		var bloque = form.querySelector('[data-bloque-organiza]');

		if (!bloque) { return; }

		var ramas = ramasMarcadas();
		var destino = ramas.length ? 'rama-' + ramas[0] : 'contacto';
		var seccion = pasos[destino];

		if (!seccion) { return; }

		bloque.hidden = destino !== pasoActual();

		// Detrás del resumen de la selección, si lo hay; si no, al principio.
		var resumen = seccion.querySelector('.reyes-sol__seleccion');

		if (resumen && resumen.nextSibling !== bloque) {
			resumen.parentNode.insertBefore(bloque, resumen.nextSibling);
		} else if (!resumen && seccion.firstChild !== bloque) {
			seccion.insertBefore(bloque, seccion.firstChild);
		}
	}

	/**
	 * Pone en los contadores de ocupación los adultos y niños de la composición.
	 *
	 * Solo en los que el visitante no haya tocado: acaba de decir con quién
	 * viaja dos pantallas antes y no tiene sentido volver a preguntárselo, pero
	 * si los cambia a mano mandan los suyos.
	 */
	function autorrellenarOcupacion() {
		var sel = form.querySelector('[data-campo="composicion_slug"]');
		var opcion = sel && sel.options[sel.selectedIndex];

		if (!opcion || !opcion.hasAttribute('data-adultos')) { return; }

		var adultos = opcion.getAttribute('data-adultos');
		var ninos = opcion.getAttribute('data-ninos');

		['noches', 'casablanca'].forEach(function (r) {
			ponerSiIntacto(r + '_adultos', adultos);
			ponerSiIntacto(r + '_ninos', ninos);
		});
	}

	function ponerSiIntacto(nombre, valorNuevo) {
		var campo = form.querySelector('[name="' + nombre + '"]');

		if (campo && !campo.hasAttribute('data-tocado')) {
			campo.value = valorNuevo;
		}
	}

	function pintarResumen() {
		var sel = form.querySelector('[data-campo="salida_slug"]');
		var comp = form.querySelector('[data-campo="composicion_slug"]');
		var textoSalida = sel && sel.options[sel.selectedIndex] ? sel.options[sel.selectedIndex].text : '';
		var textoComp = comp && comp.value ? comp.options[comp.selectedIndex].text : '';

		Array.prototype.forEach.call(raiz.querySelectorAll('[data-resumen-salida]'), function (e) {
			e.textContent = textoSalida;
		});
		Array.prototype.forEach.call(raiz.querySelectorAll('[data-resumen-composicion]'), function (e) {
			e.textContent = textoComp;
		});
	}

	// ---------- campos condicionales ----------

	function refrescarCondicionales() {
		// El número de reserva, solo si dice que la tiene.
		var conReserva = form.querySelector('[name="tiene_reserva"][value="si"]');
		Array.prototype.forEach.call(raiz.querySelectorAll('[data-si-reserva]'), function (e) {
			e.hidden = !(conReserva && conReserva.checked);
		});

		// Las noches de antes y de después, según el «cuándo» de cada rama.
		['noches', 'casablanca'].forEach(function (r) {
			var seccion = pasos['rama-' + r];
			if (!seccion) { return; }

			var elegido = seccion.querySelector('[data-cuando]:checked');
			var valor = elegido ? elegido.value : '';
			var antes = seccion.querySelector('[data-si-antes]');
			var despues = seccion.querySelector('[data-si-despues]');

			if (antes) { antes.hidden = !(valor === 'antes' || valor === 'ambas'); }
			if (despues) { despues.hidden = !(valor === 'despues' || valor === 'ambas'); }

			pintarViajeCompleto(r);
		});

		// El campo del canal de contacto elegido.
		var porTelefono = form.querySelector('[name="canal"][value="telefono"]');
		var esTelefono = porTelefono && porTelefono.checked;
		Array.prototype.forEach.call(raiz.querySelectorAll('[data-si-email]'), function (e) { e.hidden = esTelefono; });
		Array.prototype.forEach.call(raiz.querySelectorAll('[data-si-telefono]'), function (e) { e.hidden = !esTelefono; });
	}

	/**
	 * Las fechas del viaje completo.
	 *
	 * Solo para que el visitante las vea: al correo van las que calcula PHP.
	 */
	function pintarViajeCompleto(rama) {
		var seccion = pasos['rama-' + rama];
		var caja = seccion.querySelector('[data-viaje-completo]');

		if (!caja) { return; }

		var sel = form.querySelector('[data-campo="salida_slug"]');
		var opcion = sel && sel.options[sel.selectedIndex];
		var inicio = opcion ? opcion.getAttribute('data-fecha-inicio') : '';
		var fin = opcion ? opcion.getAttribute('data-fecha-fin') : '';

		var elegido = seccion.querySelector('[data-cuando]:checked');
		var valor = elegido ? elegido.value : '';
		var antes = (valor === 'antes' || valor === 'ambas') ? numero(rama + '_antes') : 0;
		var despues = (valor === 'despues' || valor === 'ambas') ? numero(rama + '_despues') : 0;

		var d1 = aFecha(inicio);
		var d2 = aFecha(fin);

		// Sin fechas en la salida no se inventa el rango: se esconde el bloque.
		if (!d1 || !d2) {
			caja.hidden = true;
			return;
		}

		d1.setDate(d1.getDate() - antes);
		d2.setDate(d2.getDate() + despues);

		caja.querySelector('[data-viaje-completo-texto]').textContent = rango(d1, d2);
		caja.hidden = false;
	}

	function aFecha(ymd) {
		if (!/^\d{8}$/.test(ymd || '')) { return null; }
		var d = new Date(+ymd.slice(0, 4), +ymd.slice(4, 6) - 1, +ymd.slice(6, 8));
		return isNaN(d.getTime()) ? null : d;
	}

	function rango(d1, d2) {
		if (d1.getFullYear() === d2.getFullYear() && d1.getMonth() === d2.getMonth()) {
			return d1.getDate() + ' - ' + d2.getDate() + ' ' + MESES[d2.getMonth()] + ' ' + d2.getFullYear();
		}
		return d1.getDate() + ' ' + MESES[d1.getMonth()] + ' ' + d1.getFullYear()
			+ ' - ' + d2.getDate() + ' ' + MESES[d2.getMonth()] + ' ' + d2.getFullYear();
	}

	function numero(nombre) {
		var c = form.querySelector('[name="' + nombre + '"]');
		return c ? Math.max(0, parseInt(c.value, 10) || 0) : 0;
	}

	// ---------- validación en cliente ----------

	function limpiarErrores() {
		Array.prototype.forEach.call(raiz.querySelectorAll('[data-error]'), function (e) {
			e.hidden = true;
			e.textContent = '';
		});
		Array.prototype.forEach.call(raiz.querySelectorAll('.is-invalido'), function (e) {
			e.classList.remove('is-invalido');
		});
		errorGlobal.hidden = true;
	}

	function marcarError(campo, mensaje) {
		var seccion = pasos[pasoActual()];
		var hueco = (seccion && seccion.querySelector('[data-error="' + campo + '"]'))
			|| raiz.querySelector('[data-error="' + campo + '"]');

		if (hueco) {
			hueco.textContent = mensaje;
			hueco.hidden = false;
		}

		var control = (seccion && seccion.querySelector('[name="' + campo + '"]'))
			|| raiz.querySelector('[name="' + campo + '"]');

		if (control) {
			control.classList.add('is-invalido');
		}

		return control || hueco;
	}

	/** Lo que se puede comprobar sin preguntar al servidor. */
	function validarPaso() {
		var actual = pasoActual();
		var errores = [];

		if (actual === '1') {
			if (!form.querySelector('[data-campo="composicion_slug"]').value) {
				errores.push(['composicion_slug', 'Elige quién viaja.']);
			}
			// Marcar una rama NO es obligatorio: se puede pedir una propuesta sin
			// adaptar nada y contarlo en el campo libre del último paso.
		}

		// El bloque de «quién organiza» se valida en el paso donde esté puesto.
		var organiza = form.querySelector('[data-bloque-organiza]');

		if (organiza && !organiza.hidden) {
			if (!valor('nombre')) { errores.push(['nombre', 'Dinos tu nombre.']); }
			if (!valor('apellidos')) { errores.push(['apellidos', 'Dinos tus apellidos.']); }

			var conReserva = form.querySelector('[name="tiene_reserva"][value="si"]');
			if (conReserva && conReserva.checked && !valor('numero_reserva')) {
				errores.push(['numero_reserva', 'Añade tu número de reserva.']);
			}
		}

		if (actual.indexOf('rama-') === 0) {
			var rama = actual.slice(5);
			var seccion = pasos[actual];

			if (rama === 'familiares') {
				if (!numero('familiares_adultos') && !numero('familiares_ninos')) {
					errores.push(['familiares_adultos', 'Añade al menos un acompañante.']);
				}
			} else {
				var elegido = seccion.querySelector('[data-cuando]:checked');
				if (!elegido) {
					errores.push([rama + '_cuando', 'Elige cuándo.']);
				} else {
					var v = elegido.value;
					if ((v === 'antes' || v === 'ambas') && numero(rama + '_antes') < 1) {
						errores.push([rama + '_antes', 'Al menos una noche.']);
					}
					if ((v === 'despues' || v === 'ambas') && numero(rama + '_despues') < 1) {
						errores.push([rama + '_despues', 'Al menos una noche.']);
					}
				}
			}

			if (!seccion.querySelector('[name="' + rama + '_regimen"]:checked')) {
				errores.push([rama + '_regimen', 'Elige un régimen.']);
			}
		}

		if (actual === 'contacto') {
			var porTelefono = form.querySelector('[name="canal"][value="telefono"]');

			if (porTelefono && porTelefono.checked) {
				if (!valor('telefono')) { errores.push(['telefono', 'Añade un teléfono.']); }
			} else if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(valor('email'))) {
				errores.push(['email', 'Añade un correo válido.']);
			}

			if (!form.querySelector('[name="acepta_privacidad"]').checked) {
				errores.push(['acepta_privacidad', 'Tienes que aceptar la política de privacidad.']);
			}
		}

		return errores;
	}

	function valor(nombre) {
		var c = form.querySelector('[name="' + nombre + '"]');
		return c ? c.value.trim() : '';
	}

	function mostrarErrores(errores) {
		limpiarErrores();

		// Un campo dentro de un bloque plegado no puede quedarse con un aviso que
		// nadie ve: se despliega antes de señalarlo.
		if (errores.some(function (e) { return e[0] === 'composicion_slug' || e[0] === 'salida_slug'; })) {
			abrirSeleccion(true);
		}

		var primero = null;
		errores.forEach(function (e) {
			var control = marcarError(e[0], e[1]);
			if (!primero) { primero = control; }
		});

		if (primero) {
			primero.scrollIntoView({ block: 'center', behavior: 'smooth' });
			if (primero.focus) { primero.focus({ preventScroll: true }); }
		}
	}

	// ---------- navegación ----------

	function avanzar() {
		var errores = validarPaso();

		if (errores.length) {
			mostrarErrores(errores);
			return;
		}

		limpiarErrores();

		if (pasoActual() === 'contacto') {
			enviar();
			return;
		}

		if (pasoActual() === '1') {
			recalcularSecuencia();
		}

		indice = Math.min(indice + 1, secuencia.length - 1);
		guardar();
		pintar();
	}

	function retroceder() {
		indice = Math.max(0, indice - 1);
		limpiarErrores();
		pintar();
	}

	/**
	 * Si cerrar ahora perdería algo que cueste volver a escribir.
	 *
	 * Marcar una opción o elegir la composición no cuenta: son un clic. Avisar
	 * por eso convierte el aviso en ruido y se acaba pulsando «sí» sin leerlo.
	 */
	function hayAlgoEscrito() {
		if (indice > 0) { return true; }

		return ['nombre', 'apellidos', 'email', 'telefono', 'comentarios'].some(function (n) {
			return valor(n) !== '';
		});
	}

	/**
	 * Deja el asistente como recién cargado.
	 *
	 * `form.reset()` devuelve cada campo a su valor de partida, incluidos los
	 * contadores; lo demás son los estados que el reset no toca.
	 */
	function empezarDeCero() {
		form.reset();
		olvidar();
		limpiarErrores();
		indice = 0;
		recalcularSecuencia();

		// El reset se lleva por delante la salida heredada de la página.
		elegirSalida(new URLSearchParams(window.location.search).get('salida'));
	}

	function abrir() {
		ultimoFoco = document.activeElement;

		// Si la vez anterior terminó en «solicitud enviada», esta es una nueva:
		// reabrir no puede dejar al visitante mirando el acuse de la otra.
		if (pasoActual() === 'gracias') {
			empezarDeCero();
		}

		raiz.hidden = false;
		document.body.classList.add('reyes-sol-abierto');

		pedirNonce();
		recalcularSecuencia();
		pintar();
		refrescarCondicionales();

		// Si no sabemos con quién viaja, se pregunta de entrada.
		abrirSeleccion(faltaComposicion());

		dialogo.focus();
	}

	function cerrar(preguntar) {
		// Desde el acuse no hay nada que perder: ya se ha enviado.
		if (preguntar && pasoActual() !== 'gracias' && hayAlgoEscrito()) {
			if (!window.confirm('Si cierras ahora perderás lo que has escrito. ¿Seguro?')) {
				return;
			}
		}

		// Cerrar en el paso 1 sin nada escrito deja el asistente como nuevo: si no,
		// reabrir enseña las opciones que se marcaron antes de cerrar y el
		// visitante acaba en un paso que no ha pedido.
		if (indice === 0 && !hayAlgoEscrito()) {
			empezarDeCero();
		}

		raiz.hidden = true;
		document.body.classList.remove('reyes-sol-abierto');

		if (ultimoFoco && ultimoFoco.focus) { ultimoFoco.focus(); }
	}

	// ---------- el nonce y el envío ----------

	function pedirNonce() {
		var cuerpoPeticion = new FormData();
		cuerpoPeticion.append('action', 'bex_reyes_solicitud_nonce');

		fetch(raiz.getAttribute('data-ajax-url'), {
			method: 'POST',
			body: cuerpoPeticion,
			credentials: 'same-origin'
		}).then(function (r) {
			return r.json();
		}).then(function (j) {
			if (j && j.success) {
				form.querySelector('[name="_nonce"]').value = j.data.nonce;
				// La hora del servidor, no la del navegador: la del navegador la
				// pone el visitante.
				form.querySelector('[name="abierto_en"]').value = j.data.ahora;
			}
		}).catch(function () {
			// Sin nonce el envío dará 403 y se verá entonces. No se avisa al
			// abrir: sería un error por algo que aún no ha intentado hacer.
		});
	}

	function enviar(reintento) {
		if (enviando) { return; }

		enviando = true;
		btnContinuar.disabled = true;

		fetch(raiz.getAttribute('data-ajax-url'), {
			method: 'POST',
			body: datosDelFormulario(),
			credentials: 'same-origin'
		}).then(function (r) {
			return r.json().then(function (j) { return { ok: r.ok, json: j }; });
		}).then(function (res) {
			enviando = false;
			btnContinuar.disabled = false;

			if (res.json && res.json.success) {
				olvidar();
				indice = secuencia.length - 1;
				pintar();
				return;
			}

			var datos = (res.json && res.json.data) || {};

			if (datos.campos) {
				irAlPrimerError(datos.campos);
				return;
			}

			errorGlobal.textContent = datos.mensaje || 'No hemos podido enviar tu solicitud.';
			errorGlobal.hidden = false;
		}).catch(function () {
			enviando = false;
			btnContinuar.disabled = false;

			// Un fallo de red se reintenta una vez; si tampoco, se dice.
			if (!reintento) {
				enviar(true);
				return;
			}

			errorGlobal.textContent = 'No hemos podido enviar tu solicitud. Comprueba tu conexión e inténtalo de nuevo.';
			errorGlobal.hidden = false;
		});
	}

	/**
	 * El POST, montado a mano.
	 *
	 * No vale `new FormData(form)` y borrar lo que sobra: el bloque de «quién
	 * organiza el viaje» se pinta en las tres ramas, así que hay tres campos
	 * llamados `nombre` en el DOM, y `FormData.delete('nombre')` se lleva por
	 * delante los tres —incluido el que sí estaba relleno—. Se recorre a mano y
	 * cada nombre se manda una sola vez.
	 */
	function datosDelFormulario() {
		var datos = new FormData();
		datos.append('action', 'bex_reyes_solicitud');

		var marcadas = ramasMarcadas();
		var puestos = {};

		Array.prototype.forEach.call(form.querySelectorAll('[name]'), function (c) {
			var nombre = c.getAttribute('name');
			var seccion = c.closest('[data-paso]');

			// Los campos de una rama sin marcar no viajan. El bloque de «quién
			// organiza» sí, esté donde esté: no es de ninguna rama.
			if (seccion && !c.closest('[data-bloque-organiza]')) {
				var paso = seccion.getAttribute('data-paso');

				if (paso.indexOf('rama-') === 0 && marcadas.indexOf(paso.slice(5)) === -1) {
					return;
				}
			}

			if (c.type === 'checkbox' || c.type === 'radio') {
				if (c.checked) { datos.append(nombre, c.value); }
				return;
			}

			if (puestos[nombre]) { return; }

			puestos[nombre] = true;
			datos.append(nombre, c.value);
		});

		return datos;
	}

	/** Lleva al paso donde está el primer campo que el servidor ha rechazado. */
	function irAlPrimerError(campos) {
		var nombres = Object.keys(campos);

		for (var i = 0; i < secuencia.length; i++) {
			var seccion = pasos[secuencia[i]];

			for (var j = 0; j < nombres.length; j++) {
				if (seccion.querySelector('[name="' + nombres[j] + '"]')) {
					indice = i;
					pintar();
					mostrarErrores(nombres.map(function (n) { return [n, campos[n]]; }));
					return;
				}
			}
		}

		errorGlobal.textContent = 'Revisa los datos, hay algo que no cuadra.';
		errorGlobal.hidden = false;
	}

	// ---------- el borrador ----------

	/**
	 * Guarda el progreso, pero solo a partir del paso 2.
	 *
	 * En el paso 1 no hay nada que merezca la pena: elegir la composición y
	 * marcar una opción son dos clics. Guardarlo hacía que al reabrir el
	 * asistente apareciera con opciones ya marcadas de una sesión anterior, y
	 * que el visitante acabara en un paso que no había pedido.
	 */
	function guardar() {
		if (indice === 0) {
			olvidar();
			return;
		}

		try {
			var datos = {};
			Array.prototype.forEach.call(form.querySelectorAll('[name]'), function (c) {
				if (c.name === '_nonce' || c.name === 'abierto_en' || c.name === 'apellido2') { return; }

				if (c.type === 'checkbox' || c.type === 'radio') {
					if (c.checked) { datos[c.name + '|' + c.value] = 1; }
				} else {
					datos[c.name] = c.value;
				}
			});
			window.sessionStorage.setItem(CLAVE, JSON.stringify({ paso: indice, datos: datos }));
		} catch (e) {
			// Navegación privada o almacenamiento lleno: el asistente funciona
			// igual, solo que sin red de seguridad.
		}
	}

	function recuperar() {
		try {
			var crudo = window.sessionStorage.getItem(CLAVE);
			if (!crudo) { return; }

			var guardado = JSON.parse(crudo);

			Object.keys(guardado.datos || {}).forEach(function (clave) {
				var partes = clave.split('|');

				if (partes.length === 2) {
					var marcado = form.querySelector('[name="' + partes[0] + '"][value="' + partes[1] + '"]');
					if (marcado) { marcado.checked = true; }
				} else {
					var campo = form.querySelector('[name="' + clave + '"]');
					if (campo) { campo.value = guardado.datos[clave]; }
				}
			});

			recalcularSecuencia();
			indice = Math.min(guardado.paso || 0, secuencia.length - 2);
		} catch (e) {
			// Un borrador ilegible no vale la pena: se empieza de cero.
		}
	}

	function olvidar() {
		try {
			window.sessionStorage.removeItem(CLAVE);
		} catch (e) {}
	}

	// ---------- enganches ----------

	raiz.addEventListener('click', function (ev) {
		var boton = ev.target.closest('[data-accion]');

		if (!boton) { return; }

		ev.preventDefault();

		switch (boton.getAttribute('data-accion')) {
			case 'continuar': avanzar(); break;
			case 'atras': retroceder(); break;
			case 'omitir':
				Array.prototype.forEach.call(pasos.actividades.querySelectorAll('input'), function (c) {
					c.checked = false;
				});
				indice = Math.min(indice + 1, secuencia.length - 1);
				pintar();
				break;
			case 'cancelar': cerrar(true); break;
			case 'cerrar': cerrar(true); break;
			case 'editar':
				abrirSeleccion(true);
				break;
		}
	});

	raiz.querySelector('[data-reyes-sol-fondo]').addEventListener('click', function () {
		cerrar(true);
	});

	document.addEventListener('keydown', function (ev) {
		if (ev.key === 'Escape' && !raiz.hidden) { cerrar(true); }
	});

	// Los contadores.
	raiz.addEventListener('click', function (ev) {
		var boton = ev.target.closest('[data-menos], [data-mas]');

		if (!boton) { return; }

		var campo = boton.parentNode.querySelector('input');
		var minimo = parseInt(campo.getAttribute('min'), 10) || 0;
		var actual = parseInt(campo.value, 10) || 0;

		// A partir de aquí manda el visitante: el autorrelleno no lo pisa.
		campo.setAttribute('data-tocado', '');
		campo.value = boton.hasAttribute('data-mas') ? actual + 1 : Math.max(minimo, actual - 1);
		campo.dispatchEvent(new Event('change', { bubbles: true }));
	});

	form.addEventListener('change', function (ev) {
		if (ev.target.hasAttribute('data-rama')) {
			avisarSiSeDescarta(ev.target);
			recalcularSecuencia();
			colocarOrganiza();
		}

		if (ev.target.getAttribute('data-campo') === 'composicion_slug') {
			autorrellenarOcupacion();
		}

		refrescarCondicionales();
		pintarResumen();
		guardar();
	});

	form.addEventListener('input', function (ev) {
		guardar();
	});

	/** Desmarcar una rama tira lo que se hubiera escrito en ella. */
	function avisarSiSeDescarta(casilla) {
		if (casilla.checked) { return; }

		var seccion = pasos['rama-' + casilla.value];

		// Escrito significa «distinto de como venía», no «no vacío»: los
		// contadores arrancan en 1 y darlos por rellenos hacía que el aviso
		// saltara siempre, incluso sin tocar nada.
		var escrito = Array.prototype.some.call(seccion.querySelectorAll('[name]'), function (c) {
			// Lo que hay en «quién organiza» no es de esta rama: no se pierde.
			if (c.closest('[data-bloque-organiza]')) { return false; }

			// Un contador que rellenó el autorrelleno tampoco cuenta: lo puso el
			// formulario, no el visitante.
			if (c.type === 'number') { return c.hasAttribute('data-tocado'); }

			return (c.type === 'radio' || c.type === 'checkbox')
				? c.checked !== c.defaultChecked
				: c.value !== c.defaultValue;
		});

		if (escrito && !window.confirm('Si desmarcas esta opción se perderá lo que has puesto en ella. ¿Seguro?')) {
			casilla.checked = true;
		}
	}

	/** Fija la salida si existe entre las del desplegable. */
	function elegirSalida(slug) {
		if (!slug) { return false; }

		var sel = form.querySelector('[data-campo="salida_slug"]');

		if (!sel || !sel.querySelector('[value="' + slug + '"]')) { return false; }

		sel.value = slug;
		return true;
	}

	/**
	 * Los botones que abren el asistente.
	 *
	 * Cualquier enlace a `#solicitud` vale. Los botones de una salida concreta
	 * —«Avisarme si se libera una jaima», «Consultar»— usan `#solicitud=5-8-dic`
	 * para que el modal arranque con esa fecha ya elegida en vez de preguntar
	 * algo que el visitante acaba de decir al pulsar.
	 */
	Array.prototype.forEach.call(document.querySelectorAll('a[href*="#solicitud"], [data-abre-solicitud]'), function (a) {
		a.addEventListener('click', function (ev) {
			ev.preventDefault();

			var href = a.getAttribute('href') || '';
			var corte = href.indexOf('#solicitud=');

			if (corte !== -1) {
				elegirSalida(href.slice(corte + 11));
			} else if (a.hasAttribute('data-salida')) {
				elegirSalida(a.getAttribute('data-salida'));
			}

			abrir();
		});
	});

	// La salida activa de la página, para no preguntar lo que ya se sabe.
	elegirSalida(new URLSearchParams(window.location.search).get('salida'));

	// Los textos de los botones, que cambian según el paso.
	btnContinuar.setAttribute('data-texto-continuar', textoContinuar.textContent);
	btnContinuar.setAttribute('data-texto-enviar', btnContinuar.getAttribute('data-texto-enviar') || 'Enviar solicitud');

	recuperar();
	recalcularSecuencia();
	refrescarCondicionales();
})();
